import { menuActionCircle } from 'components/MainMenu/styled';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { hexToRgbA } from 'utils/colors';

export const ChatBlockWrapper = styled.div`
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  align-items: center;
  flex-direction: row;
  gap: 4px;
  padding: 16px 10px 20px 10px;
  min-height: 132px;
  max-height: ${({ listMaxHeight }) => listMaxHeight + 'px'};
  overflow-x: auto;
  overflow-y: hidden;
`;

export const UserBlock = styled(NavLink)`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  text-decoration: none;
  align-items: center;
  padding: 10px 0px 16px 0px;
  border-radius: 6px;
  width: 100%;
  max-width: 88px;
  min-height: 112px;
  position: relative;
  &:hover {
    background-color: ${({ theme }) => theme.color.blackSqueeze};
    p {
      color: ${({ theme }) => theme.color.brightTurquoise} !important;
    }
  }
  p {
    color: ${({ theme, selected }) =>
      selected
        ? theme.color.brightTurquoise
        : theme.color.pickledBluewood} !important;
  }
  background-color: ${({ theme, selected, isUnseen }) =>
    selected || isUnseen ? theme.color.blackSqueeze : 'transparent'};
`;

UserBlock.ImageWrapper = styled.div`
  box-sizing: border-box;
  display: block;
  margin-bottom: 10px;
`;

UserBlock.Name = styled.p`
  cursor: pointer;
  line-height: 16px;
  display: inline-block;
  font-size: 13px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-align: center;
  padding: 2px 8px 0px 8px;
  min-height: 7px;
`;

export const StyledNewChatPlus = styled.div`
  ${menuActionCircle}
  margin-bottom: 10px;
  background: ${({ theme }) => hexToRgbA(theme.color.pickledBluewood, 0.1)};
  transition: background 0.2s ease, transform 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;

    polygon:last-of-type {
      fill: ${({ theme }) => theme.color.pickledBluewood};
    }
  }
`;

export const BoxWrapper = styled.button`
  display: flex;
  padding: 10px 0px 16px 0px;
  align-items: center;
  position: relative;
  flex-direction: column;
  max-width: 88px;
  border: none;
  border-radius: 6px;
  width: 100%;
  height: inherit;
  min-height: 112px;
  justify-content: space-between;
  cursor: pointer;
  background-color: ${({ theme }) => theme.color.blackSqueeze};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.color.blackSqueeze};

    ${StyledNewChatPlus} {
      background: ${({ theme }) =>
        hexToRgbA(theme.color.pickledBluewood, 0.16)};
    }

    .plus-title {
      color: ${({ theme }) => theme.color.brightTurquoise};
    }
  }

  &:active ${StyledNewChatPlus} {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.color.brightTurquoise};
  }

  .plus-title {
    color: ${({ theme }) => theme.color.pickledBluewood};
    font-weight: 600;
    text-align: center;
    font-family: 'Open Sans', sans-serif;
    transition: color 0.15s ease;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SkeletonBoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 88px;
  height: 112px;
  align-items: center;
  gap: 16px;
`;
